<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Prospecto
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="prospect_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Investment Info -->
        <div class="row mt-4">
            <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Datos de inversión</h4>
            </div>
        </div>
        <sys-form :inputs="prospect_investment"/>
        <!--end: Investment Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'prospects' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import prospectsService from '@/services/prospects'
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ProspectCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      prospect_details: {
        promoter_id: {
          name: 'Promotor',
          value: '',
          type: 'select',
          size: 12,
          options: []
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        mobile: {
          name: 'Celular',
          hint: 'Celular',
          value: '',
          type: 'text'
        },
        type: {
          name: 'Tipo',
          value: '',
          type: 'select',
          options: [
            { value: 'Fisica', text: 'Física', selected: true },
            { value: 'Moral', text: 'Moral' }
          ],
          size: 3
        },
        nationality: {
          name: 'Nacionalidad',
          hint: 'Nacionalidad',
          value: '',
          type: 'text',
          size: 3
        },
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text',
          size: 3
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date',
          size: 3
        }
      },
      prospect_investment: {
        investment: {
          name: 'Monto Mínimo',
          hint: 'Monto de Inversión',
          value: '',
          type: 'number'
        },
        investment_end: {
          name: 'Monto Máximo',
          hint: 'Monto de Inversión',
          value: '',
          type: 'number'
        },
        interest: {
          name: 'Tasa de Interes',
          hint: 'Tasa de Interes',
          value: '',
          type: 'number',
          min: 0,
          max: 100
        },
        investment_date: {
          name: 'Fecha Inversión desde',
          value: '',
          type: 'date'
        },
        investment_date_end: {
          name: 'Fecha Inversión hasta',
          value: '',
          type: 'date'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    promotersService.list().then(res => {
      this.prospect_details.promoter_id.options = res.data.map(promoter => {
        return { value: promoter.id, text: promoter.fullname }
      })
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let prospectInfo = { ...this.prospect_details, ...this.prospect_investment }

          let body = this.processForm(prospectInfo)
          let service = prospectsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'prospects', props: { prospect: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
    'prospect_details.type.value': function (type, oldType) {
      if (type.value === 'Moral') {
        this.prospect_details['corporate_name'] = {
          name: 'Nombre corporativo',
          hint: 'Nombre corporativo',
          value: '',
          type: 'text'
        }
      } else if (type.value === 'Fisica') {
        delete this.prospect_details['corporate_name']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/prospects/ProspectCreate.vue